export default __webpack_public_path__ + "static/JBS-3d8f6b2e1508275a9ced25829194c0b9.png";